import React from 'react';
import {Image} from "@mantine/core";

interface IProps {
    iconIndex: number;
    line1?: string;
    line2?: string;
}

const Mission: React.FC<IProps> = ( { iconIndex, line1, line2} ) => {
    return (
        <div className="w-[200px] h-[200px] border border-[#c0d7d6] rounded-full flex flex-col items-center justify-center">
            <Image src={`/images/icon_Mission-0${iconIndex}.png`} h={84} w={84}/>
            <div className="text-[#458481] text-[20px] font-black text-center">
                {line1}<br/>{line2}
            </div>
        </div>
    );
}

const Mission2: React.FC<IProps> = ( { iconIndex} ) => {
    return (
        <div className="w-[150px] h-[150px] border border-[#c0d7d6] rounded-full flex flex-col items-center justify-center">
            <Image src={`/images/icon_Mission-0${iconIndex}.png`} h={84} w={84}/>
        </div>
    );
}

export default Mission2;
